/**
 * Read-time pairing of a conversation's runtime trace with the message it belongs to (FULL-0016).
 *
 * `conversation_service` persists a reply and its trace as TWO adjacent rows — a `human_response`
 * carrying the operator-facing text, and a sibling `technical_trace` row carrying `technical_trace`.
 * The trace is therefore never a field of the row that renders it, so a panel reading
 * `message.technical_trace` alone shows nothing, while a `technical_trace` row is not a bubble at
 * all. `handoff_notice` is the one exception: it carries its trace inline, in the same row.
 *
 * This is a display projection, not a write-path change and not a rewrite of the payload: nothing
 * here is stored and no message is mutated (each row is copied). A trace row attaches to the
 * immediately preceding bubble that has somewhere to show one — the row the service wrote it after
 * — and never becomes a message of its own, so it cannot pollute the primary conversation. An
 * inline trace always wins over a sibling one.
 */
const TRACE_SLOT_TYPES = new Set(["human_response", "handoff_notice", "system"]);

export function pairConversationTraces(messages) {
  const rows = [];
  for (const message of messages || []) {
    if (!message) continue;
    if (message.message_type === "technical_trace") {
      const previous = rows[rows.length - 1];
      if (previous && previous.trace == null && TRACE_SLOT_TYPES.has(previous.message.message_type)) {
        previous.trace = message.technical_trace || null;
      }
      continue;
    }
    rows.push({ message, trace: message.technical_trace || null });
  }
  return rows;
}
